/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, BoxProps, Typography } from "@mui/material";
import React from "react";

import { Button } from "../../../../components/Button";
import TestIds from "../../../../testIds";

export interface FilterDropdownProps {
  children?: React.ReactNode | React.ReactNode[];
  onClear?: () => void;
  onSubmit?: () => void;
  title?: string;
  containerSx?: BoxProps;
}
export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  children,
  onClear,
  onSubmit,
  title,
  containerSx,
}) => {
  return (
    <Box display="grid" gap="1rem" {...containerSx}>
      {/* Clear Filters Action */}
      <Box width="100%" display="inline-flex" justifyContent="space-between" gap="1rem">
        <Typography variant="h4" paddingRight="5rem">
          {title}
        </Typography>
        <Button variant="underline" onClick={onClear}>
          Clear Filter
        </Button>
      </Box>

      {/* Middle Children */}
      {children}

      {/* Closing Action */}
      <Button
        variant="contained"
        onClick={onSubmit}
        data-testid={TestIds.components.filters.viewResults}
      >
        View results
      </Button>
    </Box>
  );
};
